module.exports = __webpack_public_path__ + "img/dokumen_internasional.ccf24b02.svg";